import { render } from "./PageFooter.vue?vue&type=template&id=54ed265a&scoped=true"
const script = {}

import "./PageFooter.vue?vue&type=style&index=0&id=54ed265a&scoped=true&lang=css"

import exportComponent from "/Users/cn7ero/workspace/timemarking/website/app.timemarking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ed265a"]])

export default __exports__